(() => {
  if (window.HermeticaPdpAjaxCart) return;
  window.HermeticaPdpAjaxCart = true;

  const formSelector = '.hsf-pdp-quick-commit__form, .hsf-mobile-buybar__form';
  const freeShippingThreshold = 6000;
  const upsellHandles = ['cozy', 'shilajitgummy', 'bluecrush', 'eternity', 'shilajittablets'];
  const productCache = new Map();
  const stagedImages = {
    'hush-gummies': 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-hush-staged.jpg?v=1772938270',
    bluecrush: 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-blue-crush-staged.jpg?v=1772938250',
    shilajitgummy: 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-deva-staged.jpg?v=1772938299',
    eternity: 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-eternity-staged.jpg?v=1772938316',
    cozy: 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-cozy-staged.jpg?v=1772938281',
    shilajittablets: 'https://cdn.shopify.com/s/files/1/0699/5751/7532/files/blog-meru-staged.jpg?v=1772938335'
  };
  const analyticsSessionKey = 'hsf_cart_measurement_session';
  let latestCart = null;
  let previousFocus = null;

  const newId = () => {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    } catch (_) {}
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  };

  const analyticsSessionId = (() => {
    try {
      let value = sessionStorage.getItem(analyticsSessionKey);
      if (!value) {
        value = newId();
        sessionStorage.setItem(analyticsSessionKey, value);
      }
      return value;
    } catch (_) {
      return 'session-unavailable';
    }
  })();

  const uuid = () => newId();
  const productHandle = (() => {
    const match = location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  })();
  const currency = window.Shopify?.currency?.active || 'USD';

  const emitCartEvent = (name, params = {}) => {
    const eventName = `hsf_${name}`;
    const payload = {
      event_id: uuid(),
      session_id: analyticsSessionId,
      page_type: 'product',
      product_handle: productHandle,
      currency,
      ...params
    };
    try {
      if (!window.dataLayer || typeof window.dataLayer.push !== 'function') window.dataLayer = [];
      window.dataLayer.push({ event: eventName, ...payload });
    } catch (_) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, { ...payload, transport_type: 'beacon' });
      }
    } catch (_) {}
  };

  const cartState = (cart = latestCart) => ({
    cart_item_count: Number(cart?.item_count || 0),
    cart_total: Number(cart?.total_price || 0) / 100
  });

  const formState = (form, formData = new FormData(form)) => {
    const sellingPlanId = String(formData.get('selling_plan') || '');
    return {
      placement: form.closest('.hsf-mobile-buybar') ? 'mobile_sticky' : 'quick_commit',
      variant_id: String(formData.get('id') || ''),
      selling_plan_id: sellingPlanId,
      purchase_type: sellingPlanId ? 'subscription' : 'one_time',
      quantity: Number(formData.get('quantity') || 1)
    };
  };

  const money = (cents) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);

  const escapeHtml = (value) =>
    String(value || '').replace(/[&<>"']/g, (char) => {
      const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
      return entities[char] || char;
    });

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart fetch failed');
    return response.json();
  };

  const fetchProduct = async (handle) => {
    if (productCache.has(handle)) return productCache.get(handle);
    const response = await fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const product = await response.json();
    productCache.set(handle, product);
    return product;
  };

  const getProductImage = (item) => {
    if (item.handle && stagedImages[item.handle]) return stagedImages[item.handle];
    if (item.image) return item.image;
    if (item.featured_image?.url) return item.featured_image.url;
    return '';
  };

  const ensureDrawer = () => {
    let drawer = document.querySelector('[data-hsf-ajax-cart]');
    if (drawer) return drawer;

    const style = document.createElement('style');
    style.id = 'hsf-ajax-cart-style';
    style.textContent = `
      html.hsf-ajax-cart-open,html.hsf-ajax-cart-open body{overflow:hidden}
      .hsf-ajax-cart{position:fixed;inset:0;z-index:2147483000;display:grid;pointer-events:none}
      .hsf-ajax-cart.is-open{pointer-events:auto}
      .hsf-ajax-cart__shade{position:absolute;inset:0;background:rgba(23,22,18,.38);opacity:0;transition:opacity .16s ease}
      .hsf-ajax-cart.is-open .hsf-ajax-cart__shade{opacity:1}
      .hsf-ajax-cart__panel{position:absolute;top:0;right:0;display:grid;grid-template-rows:auto 1fr auto;width:min(440px,100vw);height:100%;padding:18px;border-left:1px solid rgba(23,22,18,.16);background:#f8f7f3;box-shadow:none;transform:translateX(104%);transition:transform .18s ease;overflow:hidden}
      .hsf-ajax-cart.is-open .hsf-ajax-cart__panel{transform:translateX(0)}
      .hsf-ajax-cart__head{display:flex;align-items:center;justify-content:space-between;gap:16px;padding-bottom:14px;border-bottom:1px solid rgba(23,22,18,.13)}
      .hsf-ajax-cart__head h2{margin:0;color:#171612;font-size:clamp(1.5rem,2vw,2rem);line-height:1;font-weight:750;letter-spacing:0}
      .hsf-ajax-cart__close{display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;border:1px solid rgba(23,22,18,.18);border-radius:2px;background:#fff;color:#171612;font-size:1.8rem;line-height:1;cursor:pointer}
      .hsf-ajax-cart__body{display:grid;gap:14px;align-content:start;min-height:0;overflow:auto;overscroll-behavior:contain;padding:16px 2px}
      .hsf-ajax-cart__item{display:grid;grid-template-columns:76px 1fr auto;gap:12px;align-items:center;padding:10px;border:1px solid rgba(23,22,18,.12);border-radius:2px;background:#fff}
      .hsf-ajax-cart__item.is-offer-gift{border-color:#a9843f;background:#fffdf6}
      .hsf-ajax-cart__item img{width:76px;height:76px;border:1px solid rgba(23,22,18,.1);border-radius:2px;object-fit:cover;background:#efede7}
      .hsf-ajax-cart__item strong,.hsf-ajax-cart__upsell-copy strong{display:block;color:#171612;font-size:.95rem;line-height:1.18}
      .hsf-ajax-cart__item span,.hsf-ajax-cart__upsell-copy span{display:block;margin-top:4px;color:#625f59;font-size:.82rem;line-height:1.25}
      .hsf-ajax-cart__item .hsf-ajax-cart__item-plan{color:#45423c;font-weight:750}
      .hsf-ajax-cart__item-price{color:#171612;font-weight:850;font-size:.9rem;white-space:nowrap}
      .hsf-ajax-cart__shipping,.hsf-ajax-cart__trust,.hsf-ajax-cart__upsells{padding:14px;border:1px solid rgba(23,22,18,.12);border-radius:2px;background:#fff}
      .hsf-ajax-cart__gift-note{padding:13px;border:1px solid #a9843f;border-radius:2px;background:#fffdf6;color:#3e321d;font-size:.84rem;line-height:1.4}
      .hsf-ajax-cart__gift-note strong{display:block;margin-bottom:2px;color:#171612;font-size:.92rem}
      .hsf-ajax-cart__shipping-row,.hsf-ajax-cart__upsell-head{display:flex;align-items:center;justify-content:space-between;gap:12px;color:#171612;font-size:.9rem;font-weight:850}
      .hsf-ajax-cart__track{height:6px;margin-top:10px;border-radius:2px;background:#e3e0d9;overflow:hidden}
      .hsf-ajax-cart__track span{display:block;width:var(--hsf-ajax-cart-progress);height:100%;border-radius:2px;background:#a9843f}
      .hsf-ajax-cart__trust{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
      .hsf-ajax-cart__trust span{display:flex;align-items:center;gap:8px;min-height:42px;padding:8px;border:1px solid rgba(23,22,18,.1);border-radius:2px;background:#f8f7f3;color:#45423c;font-size:.74rem;font-weight:750;line-height:1.2}
      .hsf-ajax-cart__upsell-head small{color:#625f59;font-weight:650}
      .hsf-ajax-cart__upsell-grid{display:grid;gap:9px;margin-top:11px}
      .hsf-ajax-cart__upsell{display:grid;grid-template-columns:58px 1fr auto;gap:10px;align-items:center;padding:8px;border:1px solid rgba(23,22,18,.1);border-radius:2px;background:#fff}
      .hsf-ajax-cart__upsell img{width:58px;height:58px;border:1px solid rgba(23,22,18,.1);border-radius:2px;object-fit:cover;background:#efede7}
      .hsf-ajax-cart__upsell button{min-width:60px;min-height:44px;border:1px solid #171612;border-radius:2px;background:#171612;color:#f8f7f3;font-size:.76rem;font-weight:900;text-transform:uppercase;cursor:pointer}
      .hsf-ajax-cart__foot{display:grid;gap:12px;padding-top:14px;border-top:1px solid rgba(23,22,18,.13)}
      .hsf-ajax-cart__subtotal{display:flex;justify-content:space-between;gap:12px;color:#171612;font-size:1rem;font-weight:850}
      .hsf-ajax-cart__checkout{display:inline-flex;align-items:center;justify-content:center;min-height:52px;border:1px solid #171612;border-radius:2px;background:#171612;color:#f8f7f3;text-decoration:none;font-weight:900;letter-spacing:.04em;text-transform:uppercase;box-shadow:none}
      .hsf-ajax-cart__cart-link{color:#45423c;text-align:center;font-size:.82rem;font-weight:800;text-decoration:underline}
      .hsf-ajax-cart__empty{padding:32px 14px;color:#171612;text-align:center}
      .hsf-ajax-cart__close:focus-visible,.hsf-ajax-cart__checkout:focus-visible,.hsf-ajax-cart__cart-link:focus-visible,.hsf-ajax-cart__upsell button:focus-visible{outline:2px solid #8f6f32;outline-offset:2px}
      @media(prefers-reduced-motion:reduce){.hsf-ajax-cart__panel,.hsf-ajax-cart__shade{transition:none}}
      @media(max-width:749px){.hsf-ajax-cart__panel{top:auto;bottom:0;width:100%;height:min(86vh,760px);padding:14px;border-top:1px solid rgba(23,22,18,.16);border-left:0;border-radius:0;transform:translateY(104%)}.hsf-ajax-cart.is-open .hsf-ajax-cart__panel{transform:translateY(0)}.hsf-ajax-cart__item{grid-template-columns:64px 1fr}.hsf-ajax-cart__item-price{grid-column:2}.hsf-ajax-cart__trust{grid-template-columns:1fr}.hsf-ajax-cart__upsell{grid-template-columns:54px 1fr auto}.hsf-ajax-cart__head h2{font-size:1.55rem}}
    `;
    document.head.appendChild(style);

    drawer = document.createElement('div');
    drawer.className = 'hsf-ajax-cart';
    drawer.dataset.hsfAjaxCart = 'true';
    drawer.innerHTML = `
      <div class="hsf-ajax-cart__shade" data-hsf-ajax-cart-close></div>
      <aside class="hsf-ajax-cart__panel" role="dialog" aria-modal="true" aria-labelledby="hsf-ajax-cart-title">
        <header class="hsf-ajax-cart__head">
          <h2 id="hsf-ajax-cart-title">Cart</h2>
          <button type="button" class="hsf-ajax-cart__close" data-hsf-ajax-cart-close aria-label="Close cart">&times;</button>
        </header>
        <div class="hsf-ajax-cart__body" data-hsf-ajax-cart-body></div>
        <footer class="hsf-ajax-cart__foot" data-hsf-ajax-cart-foot></footer>
      </aside>
    `;
    document.body.appendChild(drawer);

    drawer.addEventListener('click', async (event) => {
      if (event.target.closest('[data-hsf-ajax-cart-close]')) {
        emitCartEvent('cart_drawer_close', cartState());
        closeDrawer();
        return;
      }

      const checkout = event.target.closest('[data-hsf-ajax-checkout]');
      if (checkout) {
        emitCartEvent('checkout_click', { placement: 'ajax_cart', ...cartState() });
        return;
      }

      const cartLink = event.target.closest('[data-hsf-ajax-cart-link]');
      if (cartLink) {
        emitCartEvent('cart_view_click', { placement: 'ajax_cart', ...cartState() });
        return;
      }

      const button = event.target.closest('[data-hsf-ajax-upsell]');
      if (!button || button.disabled) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = 'Adding';
      const variantId = String(button.dataset.variantId || '');
      emitCartEvent('cart_upsell_click', {
        placement: 'ajax_cart',
        variant_id: variantId,
        purchase_type: 'one_time',
        ...cartState()
      });
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(button.dataset.variantId), quantity: 1 })
        });
        if (!response.ok) throw new Error('Upsell add failed');
        const addedItem = await response.json();
        const cart = await fetchCart();
        emitCartEvent('cart_upsell_success', {
          placement: 'ajax_cart',
          product_id: String(addedItem.product_id || ''),
          variant_id: String(addedItem.variant_id || variantId),
          purchase_type: addedItem.selling_plan_allocation ? 'subscription' : 'one_time',
          selling_plan_id: String(addedItem.selling_plan_allocation?.selling_plan?.id || ''),
          quantity: Number(addedItem.quantity || 1),
          value: Number(addedItem.final_price || addedItem.price || 0) / 100,
          ...cartState(cart)
        });
        renderDrawer(cart, 'upsell_success');
      } catch (error) {
        emitCartEvent('cart_upsell_error', {
          placement: 'ajax_cart',
          variant_id: variantId,
          error_type: 'request_failed',
          ...cartState()
        });
        button.disabled = false;
        button.textContent = original || 'Add';
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawer();
    });

    return drawer;
  };

  const closeDrawer = () => {
    document.querySelector('[data-hsf-ajax-cart]')?.classList.remove('is-open');
    document.documentElement.classList.remove('hsf-ajax-cart-open');
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
    previousFocus = null;
  };

  const openDrawer = (reason = 'cart_add') => {
    const drawer = ensureDrawer();
    const wasOpen = drawer.classList.contains('is-open');
    if (!wasOpen) previousFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('hsf-ajax-cart-open');
    if (!wasOpen) {
      drawer.querySelector('[data-hsf-ajax-cart-close]')?.focus({ preventScroll: true });
      emitCartEvent('cart_drawer_view', { placement: 'ajax_cart', open_reason: reason, ...cartState() });
    }
  };

  const getUpsells = async (cart) => {
    const handlesInCart = new Set((cart.items || []).map((item) => item.handle).filter(Boolean));
    const candidates = upsellHandles.filter((handle) => !handlesInCart.has(handle));
    const fetched = await Promise.all(candidates.map((handle) => fetchProduct(handle).catch(() => null)));
    const products = [];

    for (const product of fetched) {
      if (products.length >= 2) break;
      const variant = product?.variants?.find((item) => item.available) || product?.variants?.[0];
      if (!product || !variant) continue;
      products.push({ product, variant });
    }

    return products;
  };

  const buildUpsellMarkup = (upsells) =>
    upsells
      .map(({ product, variant }) => {
        const image = stagedImages[product.handle] || product.featured_image || product.images?.[0] || '';
        return `
          <article class="hsf-ajax-cart__upsell">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" width="58" height="58">` : '<span></span>'}
            <div class="hsf-ajax-cart__upsell-copy">
              <strong>${escapeHtml(product.title)}</strong>
              <span>${money(variant.price)}</span>
            </div>
            <button type="button" data-hsf-ajax-upsell data-variant-id="${variant.id}">Add</button>
          </article>
        `;
      })
      .join('');

  let upsellRenderToken = 0;

  const hydrateUpsells = (cart) => {
    const token = ++upsellRenderToken;
    getUpsells(cart)
      .then((upsells) => {
        if (token !== upsellRenderToken) return;
        const slot = document.querySelector('[data-hsf-ajax-upsell-slot]');
        if (!slot) return;
        const markup = buildUpsellMarkup(upsells);
        if (!markup) {
          slot.hidden = true;
          return;
        }
        slot.innerHTML = `
          <div class="hsf-ajax-cart__upsell-head"><span>Complete the ritual</span><small>One-click add-ons</small></div>
          <div class="hsf-ajax-cart__upsell-grid">${markup}</div>
        `;
        slot.hidden = false;
      })
      .catch(() => {});
  };

  const renderDrawer = (cart, reason = 'cart_add') => {
    latestCart = cart;
    const drawer = ensureDrawer();
    const body = drawer.querySelector('[data-hsf-ajax-cart-body]');
    const foot = drawer.querySelector('[data-hsf-ajax-cart-foot]');
    const progress = Math.min(100, Math.round(((cart.total_price || 0) / freeShippingThreshold) * 100));
    const remaining = Math.max(0, freeShippingThreshold - (cart.total_price || 0));

    if (!cart.item_count) {
      body.innerHTML = '<div class="hsf-ajax-cart__empty"><strong>Your cart is empty.</strong><p>Start with one formula.</p></div>';
      foot.innerHTML = '<a class="hsf-ajax-cart__checkout" href="/collections/all">Shop formulas</a>';
      openDrawer(reason);
      return;
    }

    const giftVariantIds = new Set([46457732104412, 46458846249180]);
    const giftDiscountTitle = 'FREE Meru + Eternity with every Hush order';
    const hasHush = cart.items.some((item) => item.handle === 'hush-gummies');
    const includesOfferFreeUnit = (item) => {
      const unitPrice = Number(item.original_price ?? item.price ?? 0);
      return (
        unitPrice > 0 &&
        (item.line_level_discount_allocations || []).some(
          (allocation) =>
            allocation?.discount_application?.title === giftDiscountTitle &&
            Number(allocation?.amount || 0) >= unitPrice
        )
      );
    };
    const items = cart.items
      .map((item) => {
        const image = getProductImage(item);
        const sellingPlanName = item.selling_plan_allocation?.selling_plan?.name || '';
        const isTaggedOfferGift = item.properties?._hsf_gift_offer === 'hush-eternity-meru-20260702';
        const isAppliedGiftLine =
          hasHush && giftVariantIds.has(Number(item.variant_id)) && includesOfferFreeUnit(item);
        const purchaseLabel = isAppliedGiftLine
          ? Number(item.quantity || 0) === 1 && Number(item.final_line_price ?? item.line_price ?? 0) === 0
            ? 'Free gift with this Hush order'
            : 'Includes one free Hush gift unit'
          : isTaggedOfferGift
            ? 'Automatic gift price is being confirmed'
          : sellingPlanName
            ? `Subscription · ${sellingPlanName}`
            : 'One-time purchase';
        return `
          <article class="hsf-ajax-cart__item${isTaggedOfferGift || isAppliedGiftLine ? ' is-offer-gift' : ''}">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" width="76" height="76">` : '<span></span>'}
            <div>
              <strong>${escapeHtml(item.product_title)}</strong>
              <span>${escapeHtml(item.variant_title || 'Daily formula')} x ${item.quantity}</span>
              <span class="hsf-ajax-cart__item-plan">${escapeHtml(purchaseLabel)}</span>
            </div>
            <div class="hsf-ajax-cart__item-price">${money(item.final_line_price ?? item.line_price)}</div>
          </article>
        `;
      })
      .join('');
    const giftCount = new Set(
      cart.items
        .filter((item) => giftVariantIds.has(Number(item.variant_id)) && includesOfferFreeUnit(item))
        .map((item) => Number(item.variant_id))
    ).size;
    const giftNote =
      hasHush
        ? giftCount === 2
          ? '<section class="hsf-ajax-cart__gift-note"><strong>Your two Hush gifts are free.</strong>Eternity + Meru are included with this order. Subscription renewals are not included.</section>'
          : '<section class="hsf-ajax-cart__gift-note"><strong>Your Hush gift set is being checked.</strong>Eternity + Meru will only remain in your cart if both are free.</section>'
        : '';

    body.innerHTML = `
      ${items}
      ${giftNote}
      <section class="hsf-ajax-cart__shipping" style="--hsf-ajax-cart-progress:${progress}%">
        <div class="hsf-ajax-cart__shipping-row">
          <span>${remaining > 0 ? `${money(remaining)} from free U.S. shipping` : 'Free U.S. shipping unlocked'}</span>
          <strong>$60+</strong>
        </div>
        <div class="hsf-ajax-cart__track" aria-hidden="true"><span></span></div>
      </section>
      <section class="hsf-ajax-cart__trust" aria-label="Checkout trust signals">
        <span>30-day money-back guarantee</span>
        <span>Product details before checkout</span>
      </section>
      <section class="hsf-ajax-cart__upsells" aria-label="Recommended add-ons" data-hsf-ajax-upsell-slot hidden></section>
    `;

    foot.innerHTML = `
      <div class="hsf-ajax-cart__subtotal"><span>Estimated total</span><strong>${money(cart.total_price)}</strong></div>
      <a class="hsf-ajax-cart__checkout" href="/checkout" data-hsf-ajax-checkout>Check out</a>
      <a class="hsf-ajax-cart__cart-link" href="/cart" data-hsf-ajax-cart-link>View full cart</a>
    `;
    openDrawer(reason);
    hydrateUpsells(cart);
  };

  const updateHeaderCartCount = (cart) => {
    document.querySelectorAll('[data-testid="cart-bubble"], .cart-count-bubble, .cart-drawer__badge').forEach((node) => {
      node.textContent = cart.item_count;
      node.setAttribute('aria-label', `${cart.item_count} items in cart`);
    });
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

    const button = form.querySelector('button[type="submit"], button[name="add"]');
    const original = button ? button.textContent : '';
    const formData = new FormData(form);
    const measurement = formState(form, formData);
    let responseStatus = 0;

    try {
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });
      responseStatus = response.status;
      if (!response.ok) throw new Error('Cart add failed');
      const addedItem = await response.json();

      const cart = await fetchCart();
      updateHeaderCartCount(cart);
      emitCartEvent('cart_add_success', {
        ...measurement,
        product_id: String(addedItem.product_id || ''),
        variant_id: String(addedItem.variant_id || measurement.variant_id),
        selling_plan_id: String(
          addedItem.selling_plan_allocation?.selling_plan?.id || measurement.selling_plan_id
        ),
        purchase_type: addedItem.selling_plan_allocation ? 'subscription' : measurement.purchase_type,
        quantity: Number(addedItem.quantity || measurement.quantity),
        value: Number(addedItem.final_price || addedItem.price || 0) / 100,
        ...cartState(cart)
      });
      renderDrawer(cart, 'cart_add_success');

      if (button) {
        button.textContent = 'Added';
        window.setTimeout(() => {
          button.disabled = false;
          button.textContent = original;
        }, 1200);
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart, giftOfferHandled: productHandle === 'hush-gummies' }
        })
      );

      if (productHandle === 'hush-gummies' && window.HermeticaHushGiftOffer?.reconcile) {
        window.HermeticaHushGiftOffer.reconcile(cart, measurement)
          .then((giftResult) => {
            if (!giftResult?.cart) return;
            updateHeaderCartCount(giftResult.cart);
            if (document.querySelector('[data-hsf-ajax-cart]')?.classList.contains('is-open')) {
              renderDrawer(giftResult.cart, 'gift_offer_reconciled');
            }
          })
          .catch(() => {});
      }
    } catch (error) {
      emitCartEvent('cart_add_error', {
        ...measurement,
        http_status: responseStatus,
        error_type: 'request_failed'
      });
      if (button) {
        button.disabled = false;
        button.textContent = original || 'Add To Cart';
      }
      window.location.href = '/cart';
    }
  }, true);
})();
